// src/pages/More/More.jsx
import React, { useEffect, useState } from 'react';
import '../../Playoff.css';
import { listOfTeams } from '../teams/team';
import { ratings } from '../ratings/ratings';
import { ratings2020 } from '../ratings/ratings2020';
import { espnteams } from '../teams/espnteams';
import { espnteams2020 } from '../teams/espnteams2020';
import { espngames } from '../games/espngames';
import { espngames2020 } from '../games/espngames2020';
import { championshipGames } from '../components/champGames';
import { getTeamLogoUrl, fetchWithCache } from '../utils/helpers';
import { processSimulationData } from '../components/processSimulationData';
import LeaderboardTable from '../components/LeaderboardTable';
//import GameList from '../../components/GameList';
import PlayoffProjection from '../components/PlayoffProjection';
import RunSim from '../components/runsim';

import {resolveACCTie} from '../components/Ties/ACC';
import {resolveSECTie} from '../components/Ties/SEC';
import {resolveBig12Ties} from '../components/Ties/B12';
import {resolveBigTenTies} from '../components/Ties/B10';
import {resolveMACTie} from '../components/Ties/MAC';
import {resolveG5Tie} from '../components/Ties/G5';

const Projector2020 = ({ onPageChange, league }) => {
  const [teams, setTeams] = useState([]);
  const [games, setGames] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [refreshChampionship, setRefreshChampionship] = useState(0);
  const [odds, setOdds] = useState(0);
  const [loading, setLoading] = useState(false);
  const [UPSET_INDEX, setUPSET_INDEX] = useState(1000);
  const [week, setWeek] = useState(16);
  const [manualGames, setManualGames] = useState([]);
  const [ratingsData, setRatingsData] = useState([]);
  const [oddsFactor, setOddsFactor] = useState(false);
   const handleToggle = () => {
    setOddsFactor(prev => !prev);
    };


    const teamOdds = {
        'Ohio State': 100,
        'Indiana': 100,
        'Texas A&M': 100,
        'Texas Tech': 100,
        'Oklahoma': 100,
        'Georgia': 100,
        'Alabama': 92,
        'Notre Dame': 59,
        'Oregon': 100,
        'Ole Miss': 100,

        'James Madison': 39,
        'Virginia': 61,
        'North Texas': 58,
        
        'Tulane': 42,
        'BYU': 33,
        'Miami': 29,
        'Duke': 4,
    }

  

const updateChampionshipGames = (teams, championshipGames, manualGames = [], allGames = []) => {

  return championshipGames.map(game => {

    const confTeams = teams.filter(t => t.conference === game.conference);

    // =====================================================================
    // SUN BELT SPECIAL CASE: Division Winners Only
    // =====================================================================
    if (game.conference === "Sun Belt") {
        const SUN_BELT_DIVISIONS = {
  "Appalachian State": "East",
  "Coastal Carolina": "East",
  "Georgia Southern": "East",
  "Georgia State": "East",
  "James Madison": "East",
  "Marshall": "East",
  "Old Dominion": "East",

  "Arkansas State": "West",
  "Louisiana": "West",
  "Louisiana-Monroe": "West",
  "South Alabama": "West",
  "Southern Miss": "West",
  "Texas State": "West",
  "Troy": "West",
};

      const east = confTeams.filter(t => SUN_BELT_DIVISIONS[t.team] === "East");
const west = confTeams.filter(t => SUN_BELT_DIVISIONS[t.team] === "West");

      // helper to call the existing resolver system
      const callResolver = (winGroup) => {
        const clones = winGroup.map(team => ({ ...team }));
        if (clones.length <= 1) return clones;

        return resolveG5Tie(clones, confTeams, allGames);
      };

      function resolveDivisionWinner(divisionTeams) {
        const winsList = divisionTeams.map(t => Number(t.conferenceWins));
        const maxWins = Math.max(...winsList);

        // teams tied for division lead
        const leaders = divisionTeams.filter(
          t => Number(t.conferenceWins) === maxWins
        );

        const resolved = callResolver(leaders);
        return resolved[0]; // winner only
      }

      const eastWinner = resolveDivisionWinner(east);
      const westWinner = resolveDivisionWinner(west);

      const pair = [eastWinner.team, westWinner.team].sort();

        let updatedGame = {
        ...game,
        homeTeam: pair[0],
        awayTeam: pair[1],
      };

      // manual override (must match to apply)
      const manualEdit = manualGames.find(g => g.id === game.id);
      if (
        manualEdit &&
        manualEdit.homeTeam === updatedGame.homeTeam &&
        manualEdit.awayTeam === updatedGame.awayTeam
      ) {
        updatedGame = { ...updatedGame, ...manualEdit, manual: true };
      }

      return updatedGame;
    }

    // =====================================================================
    // NON–SUN BELT: Top 2 teams using full-conference ranking logic
    // =====================================================================

    const groups = confTeams.reduce((m, t) => {
      const k = Number(t.conferenceWins);
      if (!m.has(k)) m.set(k, []);
      m.get(k).push(t);
      return m;
    }, new Map());


    const allWinCounts = confTeams.map(t => Number(t.conferenceWins));
    const maxWins = Math.max(...allWinCounts);
    const minWins = Math.min(...allWinCounts);

    // tie-break resolver dispatcher
    function callResolver(winGroup) {

      const clones = winGroup.map(team => ({ ...team }));
      if (clones.length <= 1) return clones;

      const conference =
        (confTeams[0] && confTeams[0].conference) ||
        (game && game.conference) ||
        "Unknown";

      if (conference === "ACC") {
        return resolveACCTie(clones, confTeams, allGames);
      } else if (conference === "SEC") {
        return resolveSECTie(clones, confTeams, allGames);
      } else if (conference === "Big 12") {
        return resolveSECTie(clones, confTeams, allGames);
      } else if (conference === "Big Ten") {
        return resolveSECTie(clones, confTeams, allGames);
      } else {
          if (conference === "Mid-American") {

              return resolveMACTie(clones, confTeams, allGames);
          }
        return resolveSECTie(clones, confTeams, allGames);
      }
    }

    const sortedGroups = [];

    for (let wins = maxWins; wins >= minWins; wins--) {
      const group = groups.get(wins) || [];
      if (!group.length) continue;

      let resolved = callResolver(group);

      if (!Array.isArray(resolved)) resolved = resolved ? [resolved] : [];
      if (resolved.length && Array.isArray(resolved[0])) resolved = resolved.flat();

      resolved = resolved
        .map(t => (t && typeof t === "object" && "team" in t ? t : null))
        .filter(Boolean);

      if (resolved.length === 0) continue;

      sortedGroups.push(resolved);
      }



    const flattened = sortedGroups.flat();
    const sortedTeams = flattened;

    let updatedGame = game;

    if (sortedTeams.length >= 2) {
        const topTwo = [sortedTeams[0].team, sortedTeams[1].team].sort();
      updatedGame = {
        ...game,
        homeTeam: topTwo[0],
        awayTeam: topTwo[1],
      };
    }

    const manualEdit = manualGames.find(g => g.id === game.id);
    if (
      manualEdit &&
      manualEdit.homeTeam === updatedGame.homeTeam &&
      manualEdit.awayTeam === updatedGame.awayTeam
    ) {
      updatedGame = { ...updatedGame, ...manualEdit, manual: true };
    }

    return updatedGame;
  });
};





  const [selectedTeam, setSelectedTeam] = useState('All Teams');
  const [selectedWeek, setSelectedWeek] = useState('All Weeks');



const [rngSeed, setRngSeed] = useState(null);


 useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const ratingsDataResponse = espnteams2020;
      const gameData = espngames2020;

      setRatingsData(ratingsDataResponse);

      // 1️⃣ Generate seed if it doesn't exist, otherwise reuse
      let seedValue = rngSeed;
      seedValue = Math.floor(Math.random() * 0x7fffffff);
      setRngSeed(seedValue);

      // 2️⃣ Initial simulation to get team values
      const rand = oddsFactor ? seededRandom(seedValue) : alwaysHalf;
      const { updatedTeams, processedGames } = processSimulationData(ratingsDataResponse, gameData, week, rand, ratings2020);

      // 3️⃣ Update championship games
      const updatedChampGames = updateChampionshipGames(updatedTeams, championshipGames, [], gameData);
      const mergedGames = [...processedGames, ...updatedChampGames];

      const { updatedTeams: finalTeams, processedGames: finalGames } = processSimulationData(ratingsDataResponse, mergedGames, week, rand, ratings2020);

        handleGameChange(null, finalGames, ratingsDataResponse);
        setTeams(finalTeams);
        setGames(finalGames);
        setManualGames(finalGames);
    } catch (error) {
      console.error('Error fetching combined data:', error);
    }
    setLoading(false);
  };

  fetchData();
}, [refresh, oddsFactor]);

function seededRandom(seed) {
  let m = 0x80000000; // 2**31
  let a = 1103515245;
  let c = 12345;
  let state = seed ? seed : Math.floor(Math.random() * (m - 1));

  return function() {
    state = (a * state + c) % m;
    return state / (m - 1);
  };
}
function standard(){
    return function() {
 
    return 0.5;
  };
}
    const alwaysHalf = () => 0.5;



    const handleGameChange = (updatedGame, mg = manualGames, rd = ratingsData) => {

  // Update manualGames
        const newManualGames = mg.map(g =>
    updatedGame && g.id === updatedGame.id ? { ...g, ...updatedGame } : g
  );

        const isChampionship = updatedGame && updatedGame.id.toString().toLowerCase().includes('championship');

  // Use existing seed if it's a championship game, otherwise generate new seed
  let seedValue;
  if (isChampionship && rngSeed !== null) {
    seedValue = rngSeed;
  } else {
    seedValue = Math.floor(Math.random() * 0x7fffffff);
    setRngSeed(seedValue);
  }

    const rand = oddsFactor ? seededRandom(seedValue) : alwaysHalf;

  // Run simulation
  const regularGames = newManualGames.filter(g => !g.id.toString().toLowerCase().includes('championship'));
  const championshipGames = newManualGames.filter(g => g.id.toString().toLowerCase().includes('championship'));
  const manualChampGames = newManualGames.filter(g => g.id.toString().toLowerCase().includes('championship') && g.manual == true);

        const { updatedTeams } = processSimulationData(rd, regularGames, week, rand,
    ratings2020, true);

    const updatedChampGames = updateChampionshipGames(updatedTeams, championshipGames, manualChampGames, regularGames);
    
 const mergedGames = [...regularGames, ...updatedChampGames];

    const rand2 = oddsFactor ? seededRandom(seedValue) : alwaysHalf;

  const { updatedTeams: finalTeams, processedGames: finalGames, totalOdds } = processSimulationData(
      rd,
    mergedGames,
    week,
    rand2,
    ratings2020,
    true
  );

      const updatedChampGames2 = updateChampionshipGames(finalTeams, updatedChampGames, manualChampGames, finalGames);

  const regularGames2 = finalGames.filter(g => !g.id.toString().toLowerCase().includes('championship'));

const mergedGames2 = [...regularGames2, ...updatedChampGames2];

const { updatedTeams: finalTeams2, processedGames: finalGames2, totalOdds: totalOdds2 } = processSimulationData(
      rd,
    mergedGames2,
    week,
    rand2,
    ratings2020,
    true
  );
    const championshipGames2 = finalGames2.filter(g => g.id.toString().toLowerCase().includes('championship'));
    const mergedGames3 = [...regularGames2, ...championshipGames2];

  // Update state
  setManualGames(mergedGames3);
  setTeams(finalTeams2);
  setGames(mergedGames3);
  setOdds(totalOdds);
};

  const simulate = (r, ui) => {
    setRefresh(r);
    setUPSET_INDEX(ui);
    };

    if (false) {
        return (<RunSim />)
    }

  return (
    <div className="">
    <style dangerouslySetInnerHTML={{
  __html: `
    .manual-game-editor { margin-top: 20px; }
    .loss-img { padding: 1px; border: 2px solid transparent; border-radius: 4px; }
    body { max-width: 600px; margin: auto; }
    html { max-width: 100%; position:relative; }
    .manual-game-table { width: 100%; border-collapse: collapse; text-align: center; }
    .manual-game-table th, .manual-game-table td { padding: 10px; vertical-align: middle; }
    .manual-game-table td { width: 45%; }
    .manual-game-table .versus { width: 10%; font-weight: bold; text-align:center; }
    .clickable-team { display: flex; align-items: center; justify-content: flex-start; cursor: pointer; padding: 5px 10px; border-radius: 5px; transition: background 0.2s; }
    .clickable-team img.team-logo { width: 24px; height: 24px; margin-right: 6px; }
    .clickable-team.selected { background-color: #eee; font-weight: bold; color:#333; }
    .clickable-team.selected.manual { background-color: #aaa; font-weight: bold; color:black; }
    .manual-game-table td:last-child .clickable-team img.team-logo { margin-left: 6px; margin-right: 0; }
    #root{margin:0; max-width:100%;}
    .leaderboard .manual-game-table th{text-align:center !important;}
    .clickable-team.away{flex-direction: row-reverse;}
  `
}} />

      <div className="AppGameList leaderboard" style={{margin: "20px 0 200px"}}>
        {/*<GameList onPageChange={onPageChange} />*/}
        <br />
        <div>
                            <a href="../projection">2025</a> | <a href="../projection/2024">2024</a> |  <a href="../projection/2023">2023</a> | <a href="../projection/2022">2022</a> | <a href="../projection/2021">2021</a> | <b>2020</b> 
                            </div>
<br />
        <h1>2020 Playoff Projector</h1>
        <h5 style={{maxWidth:"450px", margin: "auto"}}>Years prior to 2024 may have minor ranking differences due to playoff critera adjustments, conference realignment, and playoff format changes.</h5>
        {!loading ? (
                  <>
                      {/*<RunSim />*/}
                       <PlayoffProjection teams={teams} listOfTeams={listOfTeams} final={week > 15} pre2024={true} />
            {/*<ManualGame
              games={games}
              onGameChange={handleGameChange}
              listOfTeams={listOfTeams}
              refreshToken={refreshChampionship}
              selectedTeam={selectedTeam}
              setSelectedTeam={setSelectedTeam}
                          selectedWeek={selectedWeek}
                          setSelectedWeek={setSelectedWeek}
            />*/}

                      <LeaderboardTable week={week} setWeek={setWeek} teamOdds={teamOdds} games={manualGames} onGameChange={handleGameChange} teams={teams} listOfTeams={listOfTeams} setSelectedTeam={setSelectedTeam} setSelectedWeek={setSelectedWeek} />
          </>
        ) : (
          <div>Refreshing...</div>
        )}
      </div>
    </div>
  );
};

export { Projector2020 };

